import React from 'react';
import { connect } from 'react-redux';
import store from '../../../store';
// LevelEditor imports
import MainNavigation from '../../MainNavigation';
import ItemSelector from './ItemSelector';
import BtnMoveMode from './ItemSelector/Container/Buttons/btnMoveMode';
// GameGuide imports
import { toggleGuide } from '../../../actions/gameGuideActions';
// Shared imports
import { LevelEditorModeEnum } from '../../../shared';

class TopBar extends React.Component {
    HandleBack = () => {
        // Set level editor state to default
        store.dispatch(toggleGuide());
    }

    ItemSelector = () => {
        const { levelEditor } = this.props;
        if (levelEditor.mode === LevelEditorModeEnum.DEFAULT || levelEditor.mode === LevelEditorModeEnum.BACKGROUND) {
            return <ItemSelector />;
        }
        return <></>;
    };

    render = () => {
        const { levelEditor } = this.props;

        const btnMove = (
            levelEditor.mode === LevelEditorModeEnum.MOVE
            ? <BtnMoveMode isMoveMode />
            : <></>
        );

        return (
            <div id="level-editor-top-bar">
                <MainNavigation 
                    BtnBackText="LEVELS"
                    BtnBackClass="leveleditor-mainnav"
                    BtnBackAlt="Terug naar Levels"
                    OnBack={this.HandleBack}
                />
                <this.ItemSelector />
                {
                    btnMove
                }
            </div>
        );
    };
}

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(mapStateToProps)(TopBar);
